module.exports = __webpack_public_path__ + "img/beijing17.beee10ab.jpg";